import LegalLayout, { LegalSection } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026" testid="terms-page">
      <p className="mt-6 text-sm text-muted-foreground leading-relaxed">
        These terms govern your use of Houses7.com. By browsing the site, creating an account or listing a
        property you accept them. If you do not agree, please do not use the platform.
      </p>

      <LegalSection title="1. What Houses7.com is">
        <p>
          We are a listing and discovery platform that connects people looking for property with owners, dealers
          and PG operators. We are not a broker, agent, builder or party to any transaction, and we do not own,
          inspect or manage the properties listed here.
        </p>
      </LegalSection>

      <LegalSection title="2. Your account">
        <p>
          You must be 18 or older and give accurate details. You are responsible for everything done through
          your account and for keeping your password safe. Tell us immediately if you suspect misuse — you can
          also sign out of other devices yourself from Dashboard → Account.
        </p>
      </LegalSection>

      <LegalSection title="3. Listing rules">
        <p>You may only list a property you own or are genuinely authorised to market.</p>
        <p>
          Details must be truthful: real photographs of that property, correct price, location, area and
          availability. No duplicate listings of the same unit and no bait pricing.
        </p>
        <p>
          Prohibited: fake or unavailable listings, misleading photos, discriminatory wording (caste, religion,
          gender, marital status or similar), abusive content, and anything unlawful.
        </p>
        <p>
          We may edit, unpublish or remove any listing, and suspend accounts that break these rules, without
          prior notice.
        </p>
      </LegalSection>

      <LegalSection title="4. Enquiries and communication">
        <p>
          When you submit an enquiry, your contact details are shared with that property's owner or dealer so
          they can reply. Do not use contact details obtained here for spam, marketing lists or any purpose
          other than the property in question.
        </p>
      </LegalSection>

      <LegalSection title="5. PG / rentals management module">
        <p>
          If you use the stay or rentals tools, you are responsible for the accuracy and lawfulness of the
          tenant and rent records you enter, and for obtaining consent from tenants to store their details.
          Rent receipts and payment reminders generated here are a convenience record; they are not a tax
          invoice or legal proof of payment on our part.
        </p>
      </LegalSection>

      <LegalSection title="6. Payments">
        <p>
          Any rent, deposit, brokerage or booking amount is paid directly between you and the other party — for
          example through the UPI details an owner has configured. Houses7.com does not collect, hold or escrow
          these amounts and is not liable for them. Verify every payee before you pay.
        </p>
      </LegalSection>

      <LegalSection title="7. Do your own due diligence">
        <p>
          Always visit the property, meet the owner, and independently verify ownership documents, approvals,
          RERA registration, dues and measurements before paying anything. Listing information is supplied by
          users and we do not warrant its accuracy.
        </p>
      </LegalSection>

      <LegalSection title="8. Intellectual property">
        <p>
          The Houses7.com name, design and software are ours. By uploading photographs or listing text you keep
          your rights, but you grant us a licence to display and promote that content on the platform and in
          our marketing. Do not upload material you do not have the rights to.
        </p>
      </LegalSection>

      <LegalSection title="9. Availability and liability">
        <p>
          The service is provided "as is". We work to keep it available but cannot guarantee uninterrupted or
          error-free operation. To the maximum extent permitted by law, we are not liable for any indirect or
          consequential loss, or for any dealing, dispute or loss arising between users.
        </p>
      </LegalSection>

      <LegalSection title="10. Suspension and changes">
        <p>
          We may suspend or terminate accounts that violate these terms, and may update these terms from time
          to time. Continued use after an update means you accept the revised terms.
        </p>
      </LegalSection>

      <LegalSection title="11. Governing law">
        <p>
          These terms are governed by the laws of India, and the courts at the location of our registered office
          shall have exclusive jurisdiction.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
